import React, { useState } from "react";
import { FacetSectionHeader } from "./FacetSectionHeader";

/**
 * Notes / comments filter. Two mutually-exclusive options:
 *   - "open": only files that have at least one UNRESOLVED note
 *   - "any":  only files that have at least one note
 *
 * `value` is one of null | "open" | "any"; clicking the active option clears it.
 * The parent translates the value into an Algolia numericFilter
 * (`noteSummary.open>0` / `noteSummary.total>0`).
 */
export function NotesFilterSection({ value, onChange, defaultExpanded = false }) {
    const [expanded, setExpanded] = useState(defaultExpanded || !!value);

    const toggle = (next) => onChange(value === next ? null : next);

    return (
        <div className="asp-facet-section">
            <FacetSectionHeader
                title="Notes"
                expanded={expanded}
                onToggle={() => setExpanded((e) => !e)}
                count={value ? 1 : 0}
            />

            {expanded && (
                <div className="asp-facet-body">
                    <label className={`asp-facet-item ${value === "open" ? "checked" : ""}`}>
                        <input
                            type="checkbox"
                            checked={value === "open"}
                            onChange={() => toggle("open")}
                        />
                        <span className="asp-facet-label">Unresolved notes only</span>
                    </label>

                    <label className={`asp-facet-item ${value === "any" ? "checked" : ""}`}>
                        <input
                            type="checkbox"
                            checked={value === "any"}
                            onChange={() => toggle("any")}
                        />
                        <span className="asp-facet-label">Has notes</span>
                    </label>
                </div>
            )}
        </div>
    );
}
